import React from 'react';
import { formatTimestamp } from '@/util/helpers/time-helpers';
import ButtonWithClose from '../ButtonWithClose';

export function buildViewChooser(
  state,
  userInteraction,
  onInsightSelected,
  ref,
) {
  const itemClicked = (view) => (e) => {
    if (view && onInsightSelected) {
      onInsightSelected(view);
    }
    const props = { section: 'insightChosen', view };
    return userInteraction(props)(e);
  };
  if (!state.chosen) {
    const terms = state.search.toLowerCase().split(' ');
    const items = state.allViews
      .filter(
        (vAndEmail) =>
          !terms.some(
            (term) =>
              vAndEmail[0].name().toLowerCase().indexOf(term) === -1 &&
              vAndEmail[1].toLowerCase().indexOf(term) === -1,
          ),
      )
      .map((vAndEmail) => (
        <a
          key={vAndEmail[0].id()}
          href="#"
          className="list-group-item"
          onClick={itemClicked(vAndEmail[0])}
        >
          {vAndEmail[0].name()}
          <div className="faint small margin-top-5">
            Updated {formatTimestamp(vAndEmail[0].saved())} by {vAndEmail[1]}
          </div>
        </a>
      ));
    const chosen = (
      <div className="vt-search-container">
        <span className="glyphicon glyphicon-search" aria-hidden="true" />
        <input
          placeholder="Search"
          className="form-control search-views"
          onChange={(e) =>
            userInteraction({ section: 'search', value: e.target.value })()
          }
          value={state.search}
          ref={ref}
        />
      </div>
    );
    const options =
      items.length === 0 ? (
        <div>
          0 queries found. Use the <b>Query Builder</b> to create and save a
          query.
        </div>
      ) : (
        <div className="list-group">{items}</div>
      );
    return { chosen, options };
  }
  const chosen = (
    <ButtonWithClose
      userInteraction={itemClicked}
      data={null}
      text={state.chosen.name()}
    />
  );
  return { chosen };
}
